export let isInitialRender = true;

export function initialRenderDone() {
  isInitialRender = false;
}
